import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {StepperData} from "./dto/stepper.dto";
import {NavSection, Section} from "../../../service/dto/section";
import {FeedbackService} from "../../../service/feedback.service";
import {Observable, tap} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrl: './stepper.component.scss'
})
export class StepperComponent implements OnInit {

  public sections: Observable<Section[]>

  constructor(
    private _feedbackService: FeedbackService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.sections = this._feedbackService.sections.pipe(
      tap((sections) => {
        const activeSection = sections.find((section) => section.isActive)
        if (activeSection) {
          this.router.navigate(["."], {
            relativeTo: this.route,
            queryParams: {
              section: activeSection.currentSection
            }
          });
        }
      })
    );
  }

  async onClickSection(selectedSection: string) {
    await this._feedbackService.navigateSection(selectedSection)
  }

}
